import { Fragment, useEffect, useState } from 'react'
import PageLayout from '../Layouts/PageLayout'
import Spinner from '../FieldComponets/Spinner';
import { useDispatch, useSelector } from 'react-redux';
import { PAGES } from '../../Constants/CommonConstants';
import { MaterialReactTable } from 'material-react-table'
import { LinkButtons } from '../FieldComponets/LinkButtons';
import { paginationQuery, handleSearch } from '../../utils/GlobalHelper';
import type { ColumnFiltersState, PaginationState } from '@tanstack/react-table';

import React from 'react';
import { CmsGetAction } from '../../Redux/Action/CmsAction';
import { getDate } from '../../utils/Helper';
import InputField from '../FieldComponets/inputField';
import { useForm } from 'react-hook-form';
import { FormattedMessage, useIntl } from 'react-intl';
function CmsPages() {

  const dispatch = useDispatch<any>();
  const intl = useIntl();

  const CmsGet = useSelector((state: any) => state.CmsGetState);



  const [data, setData] = useState<any>([]);
  const [isError, setIsError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [columnFilters, setColumnFilters] = useState<ColumnFiltersState>([]);

  const [sorting, setSorting] = useState<any>(['ASC']);

  const [pagination, setPagination] = useState<PaginationState>({
    pageIndex: PAGES?.pageIndex,
    pageSize: PAGES?.pageSize
  });
  const [searchValue, setSearchValue] = useState('');
  const [rowCount, setRowCount] = useState(0);





  // Table Coulmns
  const columns: any = [
    {
      accessorKey: 'id',
      header: intl.formatMessage({ id: "s_no" }),
      filterVariant: 'id',
      accessorFn: (row: Object, index: number) => {
        const currentPage = pagination.pageIndex + 1 || 1; // Assuming current page number, default to 1 if not provided
        const itemsPerPage = pagination.pageSize || 10; // Assuming items per page, default to 10 if not provided
        const startIndex = (currentPage - 1) * itemsPerPage;
        const serialNumber = startIndex + index + 1;
        return serialNumber;
      },
      size: 50,
      enableSorting: false,
      enableColumnOrdering: false,
      enableColumnDragging: false,
      enableColumnFilter: false
    },
    {
      accessorKey: 'title',
      header: intl.formatMessage({ id: "cms_title" }),
      enableSorting: false,
      enableColumnOrdering: false,
      enableColumnDragging: false,
      enableColumnFilter: false
    },
    {
      accessorKey: 'slug',
      header: intl.formatMessage({ id: "cms_slug" }),
      enableSorting: false,
      enableColumnOrdering: false,
      enableColumnDragging: false,
      enableColumnFilter: false
    },
    {
      accessorKey: 'user_type',
      header: intl.formatMessage({ id: "user_type" }),
      accessorFn: (row: { user_type: any; }) => row.user_type == "1" ? <p>{intl.formatMessage({ id: "customer" })}</p> : <p>{intl.formatMessage({ id: "saloon" })}</p> ,
      enableSorting: false,
      enableColumnOrdering: false,
      enableColumnDragging: false,
      enableColumnFilter: false
    },
    {
      accessorKey: 'created_at',
      header: intl.formatMessage({ id: "created_at" }),
      accessorFn: (row: { created_at: any; }) => getDate(row.created_at),
      // dateSetting: { locale: "en-GB" },
      size: 100,
      filterVariant: 'date',
      enableSorting: false,
      enableColumnOrdering: false,
      enableColumnDragging: false,
      enableColumnFilter: false,
    },
    {
      header: intl.formatMessage({ id: "action" }),
      size: 50,
      accessorFn: (row: { id: any; }) => <>
        <div className="btn-group action-btn-table">
          <ul style={{ listStyleType: "none", marginLeft: "-24px" }}>
            <span>
              <LinkButtons
                pageLink={`cms-pages/edit`}
                pageID={row?.id}
                showEdit={true}
                showView={false}
                showDelete={false}
              />
            </span>
          </ul>
        </div>
      </>,
      enableSorting: false,
      enableColumnOrdering: false,
      enableColumnDragging: false,
      enableColumnFilter: false
    },
  ];

  useEffect(() => {
    const fetchData = async () => {
      if (!data.length) {
        setLoading(true);
      } else {
        setIsRefetching(true);
      }
      try {
        let query: any = paginationQuery(
          pagination.pageIndex,
          pagination.pageSize,
          sorting,
          searchValue,
          columnFilters,

        );

        await dispatch(CmsGetAction(query));

      } catch (error) {
        setIsError(true);
        return;
      }
      setIsError(false);
      setLoading(false);
      setIsRefetching(false);
    };
    fetchData();
  }, [
    columnFilters,
    searchValue,
    pagination.pageIndex,
    pagination.pageSize,
    sorting,
  ]);
  useEffect(() => {
    setData(CmsGet?.data?.data?.rows);
    setRowCount(CmsGet?.data?.data?.count);
  }, [CmsGet?.data]);



  return (
    <Fragment>
      {(loading || CmsGet?.loading) ? <Spinner /> : ""}


      <PageLayout
        title={<FormattedMessage id="cms_pages" />}
        breadcrumbs={{
          secLast: { 'link': '/cms-page', 'name': <FormattedMessage id="cms_pages" /> },
        }}
        buttons={[
          { url: '/class-add', className: 'btn btn-primary', text: '+ Add Sponsors', show: false }, // This button will be shown
        ]}
      >



        {
          data &&
          <MaterialReactTable
            columns={columns}
            data={data}
            enableGlobalFilter={false}

            enableHiding={false}
            enableColumnFilters={false}
            enableDensityToggle={false}
            enableColumnActions={false}
            enableFullScreenToggle={false}
            positionToolbarAlertBanner="top"
            // enableStickyHeader={true}
            // enableStickyFooter={true}
            initialState={{ showColumnFilters: false }}
            manualFiltering
            manualPagination
            manualSorting
            muiToolbarAlertBannerProps={
              isError
                ? {
                  color: 'error',
                  children: intl.formatMessage({ id: "error_loading_data" }),
                }
                : undefined
            }
            muiSearchTextFieldProps={{
              placeholder: intl.formatMessage({ id: "search_from_name" }),

            }}
            onColumnFiltersChange={setColumnFilters}
            onGlobalFilterChange={(value: any) => handleSearch(
              value,
              // dispatch,
              // HorseShowGetAction, 
              // setPagination, 
              setIsError,
              setLoading,
              setIsRefetching,
              setSearchValue,
              // pagination, 
              // sorting, 
              // columnFilters,
            )
            }
            onPaginationChange={setPagination}
            onSortingChange={setSorting}
            rowCount={rowCount}
            state={{
              columnFilters,
              // globalFilter,
              // isLoading,
              pagination,
              showAlertBanner: isError,
              showProgressBars: isRefetching,
              sorting,
            }}
          />
        }

      </PageLayout>
    </Fragment>
  )
}

export default CmsPages;